<style lang="scss">
  .timeinput {
      width: 45px;
  }
  .high-row {
      height: 42px;
  }
  .lighter-input {
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: #c4c4c4;
    }
    &::-moz-placeholder { /* Firefox 19+ */
      color: #c4c4c4;
    }
    &:-ms-input-placeholder { /* IE 10+ */
      color: #c4c4c4;
    }
    &:-moz-placeholder { /* Firefox 18- */
      color: #c4c4c4;
    }
  }
</style>
<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">新增休息紀錄</div>
                <div class="panel-body">
                    <form v-bind:action="'/api/attendance/' + attendanceUuid + '/time/' + attendanceTimeId + '/resting'" method="post" class="create-form form-inline" v-on:submit.prevent="createForm">
                        <div class="row high-row">
                            <div class="col-sm-12" v-show="!showCreate">
                                <input type="button" class="btn btn-default" value="新增" v-on:click.prevent="showCreate=true">
                            </div>
                        </div>
                        <div v-show="showCreate">
                            <div class="row high-row">
                                <label class="col-sm-2">
                                    時間
                                </label>
                                <div class="col-sm-10">
                                    <input type="number" class="timeinput" name="hour" min="0" max="23" v-model="newResting.hour"> 小時
                                    <input type="number" class="timeinput" name="minute" min="0" max="59" v-model="newResting.minute"> 分
                                </div>
                            </div>

                            <div class="row high-row">
                                <label class="col-sm-2">
                                    事由
                                </label>
                                <div class="col-sm-9">
                                    <input type="text" name="excuse" placeholder="吃飯" v-model="newResting.excuse" class="lighter-input">
                                </div>
                            </div>
                            <div class="row high-row">
                                <div class="col-sm-12">
                                    <input type="submit" class="btn btn-default" value="儲存" v-bind:disabled="loading">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="panel-heading">修改休息紀錄</div>

                <div class="panel-body" v-for="resting in restings">
                    <form v-bind:action="'/api/attendance/resting/' + resting.uuid" method="post" class="form-inline" v-on:submit.prevent="updateForm">
                        <div v-show="!checkRowOpened(resting.uuid)">
                            事由：{{resting.excuse}} <br>
                            時間：{{resting.hour}} 小時 {{resting.minute}} 分
                            <button class="btn btn-default" v-on:click.prevent="openRow(resting.uuid)">修改</button>
                        </div>
                        <div v-show="checkRowOpened(resting.uuid)">
                            <div class="row high-row">
                                <input type="hidden" name="_method" value="put">
                                <label class="col-sm-2">
                                    時間
                                </label>
                                <div class="col-sm-10">
                                    <input type="number" class="timeinput" name="hour" min="0" max="23" v-model="resting.hour"> 小時
                                    <input type="" class="timeinput" name="minute" min="0" max="59" v-model="resting.minute"> 分
                                </div>
                            </div>

                            <div class="row high-row">
                                <label class="col-sm-2">
                                    事由
                                </label>
                                <div class="col-sm-9">
                                    <input type="text" name="excuse" placeholder="吃飯" v-model="resting.excuse" class="lighter-input">
                                </div>
                            </div>
                            <div class="row high-row">
                                <div class="col-sm-12">
                                    <input type="submit" class="btn btn-success" value="更新" v-bind:disabled="loading">
                                    <input type="submit" class="btn btn-danger" value="刪除" v-bind:disabled="loading" v-on:click.prevent="deleteItem(resting.uuid)">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['attendance-uuid', 'attendance-time-id'],

        computed: {
            restingTemplate: function() {
                return {excuse: '', hour: 1, minute: 0};
            },
        },

        data() {
            var restings = [];
            var newResting = {excuse: '', hour: 1, minute: 0};;

            return {
                restings,
                newResting,
                loading: false,
                showCreate: false,
                openedRow: [],
            }
        },

        methods: {
            openRow: function(index) {
                if (this.openedRow.indexOf(index) === -1) {
                    this.openedRow.push(index);
                }
            },
            closeRow: function(index) {
                var keyIndex;
                if ((keyIndex = this.openedRow.indexOf(index)) !== -1) {
                    this.openedRow.splice(keyIndex, 1);
                }
            },
            checkRowOpened: function (index) {
                return this.openedRow.indexOf(index) !== -1;
            },
            updateForm: function(event) {
                var form = event.target;
                var formData = new FormData(form);
                var target = form.action;

                this.loading = true;

                this.$http.post(target, formData)
                    .then(((response) => {
                        this.requestResting();
                        swal('修改成功');
                        this.loading = false;
                        this.closeRow(response.data.uuid);
                    }).bind(this), (response) => {
                        var errors = response.data;
                        this.loading = false;
                    })
                ;
            },
            createForm: function(event) {
                var form = event.target;
                var formData = new FormData(form);
                var target = form.action;

                this.loading = true;

                this.$http.post(target, formData)
                    .then(((response) => {
                        this.requestResting();
                        this.loading = false;
                        this.newResting = this.restingTemplate;
                        this.showCreate = false;
                        swal('新增成功');
                      }).bind(this), (response) => {
                        var errors = response.data;
                        var errorString = '';
                        var key;
                        for (key in errors) {
                            errorString += errors[key];
                        }
                        swal('新增失敗', errorString)
                        this.loading = false;
                    })
                ;
            },
            parseResting: function(data) {
                var hour = Math.floor(data.duration / 3600);
                var minute = Math.floor((data.duration - hour * 3600) / 60);

                data.hour = hour;
                data.minute = minute;

                return data;
            },
            requestResting: function() {
                this.$http.get('/api/attendance/' + this.attendanceUuid + '/time/' + this.attendanceTimeId + '/resting')
                        .then((function(response) {
                            var data = response.data;
                            
                            if (typeof(data) === 'string') {
                              data = JSON.parse(data);
                            }
                            
                            this.restings = data.map(this.parseResting);
                        }).bind(this), function(response) {
                            console.error('fail to get resting data', response);
                        });
            },
            deleteItem: function(restingUuid) {
                swal({
                    title: "確定刪除?",
                    text: "再確定一下喔!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "刪!",
                    closeOnConfirm: false
                }, (function(){
                    this.loading = true;
                    this.$http.post('/api/attendance/resting/' + restingUuid, {_method: 'delete'})
                            .then((function(response) {
                                swal('成功刪除');
                                this.requestResting();
                                this.loading = false;
                            }).bind(this), function(response) {
                                swal('無法刪除');
                                console.error('fail to get resting data', response);
                                this.loading = false;
                            });
                }).bind(this));
            }
        },

        mounted() {
            this.requestResting();
        }
    }
</script>
